<div class="navbar-content sidenav-horizontal" id="layout-sidenav">
  <a class="sidenav-horizontal-prev" [ngClass]="prevDisabled" (click)="scrollMinus()"></a>
  <div #navbarWrapper class="sidenav-horizontal-wrapper">
    <ul
      #navbarContent
      id="side-nav-horizontal"
      class="nav coded-inner-navbar sidenav-inner"
      (clickOutside)="fireLeave()"
      (mouseleave)="fireLeave()"
    >
      <ng-container *ngFor="let item of menus">
        <app-menu-group-horizontal *ngIf="item.type === 'group'" [item]="item"></app-menu-group-horizontal>
        <app-menu-collapse *ngIf="item.type === 'collapse'" [item]="item"></app-menu-collapse>
        <app-menu-item *ngIf="item.type === 'item'" [item]="item"></app-menu-item>
      </ng-container>
    </ul>
  </div>
  <a class="sidenav-horizontal-next" [ngClass]="nextDisabled" (click)="scrollPlus()"></a>
</div>
